<img *ngIf="hasProductImage"
     class="image"
     [src]="fullUrl"
     (error)="onFailToLoad($event)" />

<mat-icon *ngIf="!hasProductImage"
          class="missing">
    photo_camera
</mat-icon>
